import React, { useState, useEffect } from 'react';
import Feed from './components/Feed';
import CreatePost from './components/CreatePost';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import Sidebar from './components/Sidebar';
import About from './components/About';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('feed');
  const [refreshKey, setRefreshKey] = useState(0);
  const [user, setUser] = useState(null);
  const [authView, setAuthView] = useState('login');
  const [selectedCategory, setSelectedCategory] = useState('todas');

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handlePostCreated = () => {
    setRefreshKey((prev) => prev + 1);
    setCurrentPage('feed');
  };

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleRegister = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setCurrentPage('feed');
  };

  const handleNavigate = (page) => {
    setCurrentPage(page);
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setCurrentPage('feed');
  };

  if (!user) {
    return (
      <div className="App">
        {authView === 'login' && (
          <Login 
            onLogin={handleLogin} 
            onSwitchToRegister={() => setAuthView('register')}
            onSwitchToForgot={() => setAuthView('forgot')}
          />
        )}
        {authView === 'register' && (
          <Register 
            onRegister={handleRegister} 
            onSwitchToLogin={() => setAuthView('login')}
          />
        )}
        {authView === 'forgot' && (
          <ForgotPassword 
            onBack={() => setAuthView('login')}
          />
        )}
      </div>
    );
  }

  return (
    <div className="App">
      <Sidebar 
        currentPage={currentPage}
        onNavigate={handleNavigate}
        selectedCategory={selectedCategory}
        onCategorySelect={handleCategorySelect}
      />
      
      <div className="main-layout">
        <nav className="navbar">
          <div className="nav-container">
            <h1 className="nav-brand">panchi's world ★</h1>
            <div className="user-menu">
              <span className="username">Hola, {user.username}</span>
              <button className="logout-btn" onClick={handleLogout}>
                Cerrar Sesión
              </button>
            </div>
          </div>
        </nav>

        <main className="main-content">
          {currentPage === 'feed' && (
            <Feed 
              key={refreshKey} 
              selectedCategory={selectedCategory}
            />
          )}
          {currentPage === 'create' && (
            <CreatePost onPostCreated={handlePostCreated} />
          )}
          {currentPage === 'about' && <About />}
        </main>
      </div>
    </div>
  );
}

export default App;